/* eslint-disable */
/**
 * @author Leonel Martinez
 * @description `vehicleService`
 * @exports vehicleService
 */
import { API } from "@/services";
import { http, removeNulls } from "@/utils";

const selectAPI = (service, params = {}) => {
  const { year, make, model, vehicleID } = params;

  return ({
    years: `${API.VEHICLE.YEARS}`,
    makes: `${API.VEHICLE.MAKES}/${year}`,
    models: `${API.VEHICLE.MODELS}/${year}/${make}`,
    engines: `${API.VEHICLE.ENGINES}/${year}/${make}/${model}`,
    vehicles: API.VEHICLE.VEHICLES_LIST,
    vehicleID: `${API.VEHICLE.VEHICLES_LIST}/${vehicleID}`
  }[service])
};

/**
 * @description Fetch data based on the `service` param that looks for the correct API
 * @param {string} service Service name
 * @param {object} params 
 * @returns {Array} 
 */

const getData = (service, params) =>
  http.get(selectAPI(service, params), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  })
    .catch(e => e.response);


/**
 * @description Creates a new vehicle based on the YEAR-MAKE-ENGINE-MODEL
 * @param {object} ymme
 * @returns {object} vehicle created
 */
function create(ymme, vin ) {
  // Check that all props of the ymme are set up or reject the promise
  for (const prop in ymme)
    if (!ymme[prop])
      return { statusText: "YMME PROP ERROR" };

  return http.post(API.VEHICLE.CREATE, { ymme, vin }).catch(e => e.response);
}

/**
 * @description Updates the selected vehicle
 * @param {object} vehicle
 * @returns {void}
 */
function update(vehicle) {
  let cleanVehile = removeNulls(vehicle);
  return http.put(`${API.VEHICLE.UPDATE}/${vehicle.id}`, cleanVehile);
}

export const vehicleService = {
  create,
  update,
  getData
};
